import {useEffect, useState} from "react";
import GenericDropdownCard from "./GenericDropdownCard"
import org_api from "../api/admin/admin_orgs"
import val_api from "../api/valuation"


const DefaultReportLengthSelect = (props) => {

    const [reportLengths, setReportLengths] = useState([])
    const [defaultReportLength, setDefaultReportLength] = useState(null)
    const [enableUpdate, setEnableUpdate] = useState(false)

    useEffect(() => {
        val_api.getValuationReportLength(null, null).then(response => {
            setReportLengths(response.data.types)
        })
    }, []);

    useEffect(() => {
        if (!reportLengths.length) return
        const _current = reportLengths.find(item => item.id === props.defaultReportLengthId)
        setDefaultReportLength(_current ? _current : null)
        setEnableUpdate(true)
    }, [reportLengths]);

    useEffect(() => {
        updateDefaultReportLength()
    }, [defaultReportLength]);

    const updateDefaultReportLength = () => {
        if (!enableUpdate || !defaultReportLength) return;
        org_api.postDefaultReportLength(props.org_id, {
            "default_report_length_id": defaultReportLength.id
        })
    }

    return (
        <div className="commercial-valuation-requests-toggle-container">
            <div className="commercial-valuation-requests-toggle-title">Default report length</div>
            <div className="commercial-valuation-requests-toggle">
                <GenericDropdownCard title={"Default report length"} default="Select report length"
                                      value={defaultReportLength} options={reportLengths}
                                      setValue={setDefaultReportLength} />
            </div>
        </div>
    )
}


export default DefaultReportLengthSelect
